import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const { exchangeGoogleSession, refresh } = useAuth();
  const nav = useNavigate();
  const processed = useRef(false);
  const [msg, setMsg] = useState("Signing you in…");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = typeof window !== "undefined" ? window.location.hash : "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      setMsg("No session found. Redirecting…");
      nav("/login");
      return;
    }
    const sid = decodeURIComponent(m[1]);
    (async () => {
      try {
        const user = await exchangeGoogleSession(sid);
        // Clean the hash so it doesn't process twice
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${user.name || user.email}`);
        if (!user.role) nav("/auth/role-select");
        else if (user.role === "vendor") nav("/vendor/dashboard");
        else nav("/customer/dashboard");
      } catch (e) {
        toast.error("Sign-in failed");
        await refresh();
        nav("/login");
      }
    })();
  }, [exchangeGoogleSession, nav, refresh]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-950 text-white">
      <div className="text-center">
        <div className="mx-auto h-10 w-10 animate-spin rounded-full border-2 border-lime-400 border-t-transparent" />
        <p className="mt-4 text-sm text-neutral-300" data-testid="auth-callback-msg">{msg}</p>
      </div>
    </div>
  );
}
